import type { ReactNode } from 'react';

export enum LayoutDrawerPosition {
  Left = 1,
  Right = 2,
}

export interface LayoutDrawerProps {
  children?: ReactNode;
  title: string;
  width: number | string;
  maxWidth?: number | string;
  position: LayoutDrawerPosition;
  open: boolean;
  onOpen: () => void;
}
